import './style.css';
import { Router } from './router';
import { homePage } from './pages/home';
import { aboutPage } from './pages/about';
import { contactPage } from './pages/contact';
import { sigortaSirketleriPage } from './pages/sigorta-sirketleri';
import { sssPage } from './pages/sss';
import { aracSigortlariPage } from './pages/hizmetler/arac-sigortlari';
import { konutIsyeriPage } from './pages/hizmetler/konut-isyeri';
import { saglikHayatPage } from './pages/hizmetler/saglik-hayat';
import { tarimHayvancilikPage } from './pages/hizmetler/tarim-hayvancilik';
import { muhendislikInsaatPage } from './pages/hizmetler/muhendislik-insaat';
import { seyahatOzelPage } from './pages/hizmetler/seyahat-ozel';
import { ticariKurumsalPage } from './pages/hizmetler/ticari-kurumsal';
import { aracMuayenePage } from './pages/hizmetler/arac-muayene';
import { aracDegerKaybiPage } from './pages/hizmetler/arac-deger-kaybi';
import { teklifAlPage } from './pages/teklif-al';
import { loginPage } from './pages/login';
import { dashboardPage } from './pages/dashboard';
import { myRuhsatlarPage } from './pages/my-ruhsatlar';
import { myPoliciesPage } from './pages/my-policies';
import { adminDashboardPage } from './pages/admin/index';
import { adminUsersPage } from './pages/admin/users';
import { adminRuhsatlarPage } from './pages/admin/ruhsatlar';
import { adminPolicelerPage } from './pages/admin/policeler';
import { adminTekliflerPage } from './pages/admin/teklifler';
import { adminMuayenelerPage } from './pages/admin/muayeneler';
import { adminBelgelerPage } from './pages/admin/belgeler';
import { adminIptallerPage } from './pages/admin/iptaller';

// Initialize Router
const router = new Router('app');

// Public Routes
router.addRoute('/', homePage);
router.addRoute('/hakkimizda', aboutPage);
router.addRoute('/bize-ulasin', contactPage);
router.addRoute('/anlasmali-sigorta-sirketleri', sigortaSirketleriPage);
router.addRoute('/sikca-sorulan-sorular', sssPage);

// Service Pages
router.addRoute('/hizmetler/arac-sigortlari', aracSigortlariPage);
router.addRoute('/hizmetler/konut-isyeri', konutIsyeriPage);
router.addRoute('/hizmetler/saglik-hayat', saglikHayatPage);
router.addRoute('/hizmetler/tarim-hayvancilik', tarimHayvancilikPage);
router.addRoute('/hizmetler/muhendislik-insaat', muhendislikInsaatPage);
router.addRoute('/hizmetler/seyahat-ozel', seyahatOzelPage);
router.addRoute('/hizmetler/ticari-kurumsal', ticariKurumsalPage);
router.addRoute('/hizmetler/arac-muayene', aracMuayenePage);
router.addRoute('/hizmetler/arac-deger-kaybi', aracDegerKaybiPage);
router.addRoute('/teklif-al', teklifAlPage);

router.addRoute('/giris', loginPage);

// User Routes (Auth Required)
router.addRoute('/hesabim', dashboardPage);
router.addRoute('/ruhsatlarim', myRuhsatlarPage);
router.addRoute('/policelerim', myPoliciesPage);

// Admin Routes
router.addRoute('/admin', adminDashboardPage);
router.addRoute('/admin/kullanicilar', adminUsersPage);
router.addRoute('/admin/ruhsatlar', adminRuhsatlarPage);
router.addRoute('/admin/policeler', adminPolicelerPage);
router.addRoute('/admin/teklifler', adminTekliflerPage);
router.addRoute('/admin/muayeneler', adminMuayenelerPage);
router.addRoute('/admin/belgeler', adminBelgelerPage);
router.addRoute('/admin/iptaller', adminIptallerPage);

// Update header based on auth state
function updateAuthHeader() {
  const userData = localStorage.getItem('user');
  const user = userData ? JSON.parse(userData) : null;

  const loginBtn = document.getElementById('loginBtn');
  const userMenu = document.getElementById('userMenu');
  const userName = document.getElementById('userName');
  const adminLink = document.getElementById('adminLink');
  const adminDivider = document.getElementById('adminDivider');

  if (user) {
    // User is logged in
    if (loginBtn) loginBtn.style.display = 'none';
    if (userMenu) userMenu.style.display = 'block';
    if (userName) userName.textContent = user.ad;

    // Show admin link if admin
    if (user.rol === 'admin') {
      if (adminLink) adminLink.style.display = 'block';
      if (adminDivider) adminDivider.style.display = 'block';
    }
  } else {
    // User is not logged in
    if (loginBtn) loginBtn.style.display = 'flex';
    if (userMenu) userMenu.style.display = 'none';
  }
}

// Mobile Menu Toggle
document.addEventListener('DOMContentLoaded', () => {
  const hamburger = document.querySelector('.hamburger');
  const nav = document.querySelector('.nav');
  const body = document.body;

  hamburger?.addEventListener('click', () => {
    nav?.classList.toggle('active');
    hamburger.classList.toggle('active');
    body.classList.toggle('menu-open');
  });

  // Close mobile menu when clicking outside
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    if (!target.closest('.nav') && !target.closest('.hamburger') && nav?.classList.contains('active')) {
      nav?.classList.remove('active');
      hamburger?.classList.remove('active');
      body.classList.remove('menu-open');
    }
  });

  // Mobile Dropdown Toggle
  const dropdownToggles = document.querySelectorAll('.nav-dropdown > .nav-link');
  dropdownToggles.forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      if (window.innerWidth <= 1024) {
        e.preventDefault();
        const dropdown = toggle.parentElement;
        dropdown?.classList.toggle('active');
      }
    });
  });

  // Testimonial Navigation
  let currentTestimonial = 0;
  const testimonials = [
    {
      text: 'Trafik sigortamı YILDIZ360 üzerinden yaptırdım. Hem hızlı hem de uygun fiyatlı. Kesinlikle tavsiye ederim!',
      author: 'Harun Oruç',
      role: 'Araç Sahibi',
      initials: 'HO',
    },
    {
      text: 'Kasko sigortası için en iyi teklifi YILDIZ360\'tan aldım. Profesyonel ekip ve güvenilir hizmet. Teşekkürler!',
      author: 'Sezair Yıldız',
      role: 'Şirket Yöneticisi',
      initials: 'SY',
    },
    {
      text: 'DASK sigortamı yenilemem gerekiyordu, YILDIZ360 ile işlemler çok kolay ve hızlı oldu. Memnuniyetimi belirtmek isterim.',
      author: 'Elif Demir',
      role: 'Ev Sahibi',
      initials: 'ED',
    },
    {
      text: 'Tamamlayıcı sağlık sigortası için danıştım, en uygun paketi bulmamda çok yardımcı oldular. Profesyonel hizmet!',
      author: 'Mehmet Kaya',
      role: 'Öğretmen',
      initials: 'MK',
    },
  ];

  function updateTestimonials() {
    const testimonial = testimonials[currentTestimonial];
    const testimonialText = document.querySelector('.testimonial-text');
    const testimonialAuthorAvatar = document.querySelector('.testimonial-author .avatar-placeholder');
    const testimonialAuthorName = document.querySelector('.testimonial-author h4');
    const testimonialAuthorRole = document.querySelector('.testimonial-author p');

    if (testimonialText) testimonialText.textContent = testimonial.text;
    if (testimonialAuthorAvatar) testimonialAuthorAvatar.textContent = testimonial.initials;
    if (testimonialAuthorName) testimonialAuthorName.textContent = testimonial.author;
    if (testimonialAuthorRole) testimonialAuthorRole.textContent = testimonial.role;
  }

  // Event delegation for testimonial buttons (works after router updates)
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;

    if (target.closest('#prev-testimonial')) {
      currentTestimonial = (currentTestimonial - 1 + testimonials.length) % testimonials.length;
      updateTestimonials();
    }

    if (target.closest('#next-testimonial')) {
      currentTestimonial = (currentTestimonial + 1) % testimonials.length;
      updateTestimonials();
    }
  });

  // Initialize auth header
  updateAuthHeader();

  // Logout button handler
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement;
    if (target.closest('#logoutBtn')) {
      e.preventDefault();
      localStorage.removeItem('user');
      updateAuthHeader();
      window.location.href = '/';
    }
  });

  // Initialize router
  router.init();
});
